import React from 'react';

export default function Cancel() {
  return (
    <svg xmlns = "http://www.w3.org/2000/svg" viewBox = "0 0 297 297" style = {{enableBackground: "new 0 0 297 297"}}>
      <g>
        <path d="m293.805 219.495-71.019-71.003 70.998-71.015c4.258-4.259 4.256-11.163-.002-15.422L234.921 3.194C232.875 1.149 230.101 0 227.209 0c-2.893 0-5.667 1.15-7.712 3.196l-70.999 71.025L77.477 3.219c-4.26-4.258-11.162-4.257-15.422.001L3.194 62.081C1.149 64.127 0 66.901 0 69.794s1.15 5.666 3.196 7.711l71.035 71.01-70.983 71.01c-4.257 4.258-4.257 11.16 0 15.419l58.834 58.859c2.045 2.046 4.819 3.196 7.712 3.196h.001c2.893 0 5.667-1.149 7.712-3.195l71.013-71.029 71.005 70.979c4.258 4.258 11.161 4.258 15.419 0l58.86-58.834c2.046-2.045 3.196-4.819 3.196-7.713 0-2.892-1.149-5.666-3.195-7.712z"/>
      </g>
    </svg>
  );
}